define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var BillItemModel = /** @class */ (function () {
        function BillItemModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.Name = ko.observable("");
            this.Description = ko.observable("");
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, BillItemModel.Mapping, self);
            }
        }
        BillItemModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new BillItemModel(options.data);
            }
        };
        return BillItemModel;
    }());
    return BillItemModel;
});
//# sourceMappingURL=BillItemModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/BillItemModel.js
// module id = 74
// module chunks = 2